export default __webpack_public_path__ + "static/media/cross_gry.5dd18e6b.svg";